import React, { useState, useEffect } from 'react';
import { api, apis, inWindow, wait, environment } from 'api';
import styles from './qrcode.module.scss';
const loginApi = api.requireLogicalApi(apis.loginApiImpl);
const trackerApi = api.requireLogicalApi(apis.dataTrackerApiImp);
const systemApi = api.getSystemApi();
import { doLoginPageClickDataTrack } from './../dataTracker';
import { getIn18Text } from 'api';
import { Popover } from 'antd';
import qrCodeImage from '../../../icons/app-qr-code.png';
import qrCodeTestImage from '../../../icons/app-qr-code-test.png';
const QrCheckStatus = {
    init: 0,
    scaning: 1,
    pass: 2,
    expire: 3,
};
let isRequestingQrCodeStatus = false;
const env = typeof environment === 'string' ? environment : 'local';
const isOnline = ['test_prod', 'prod', 'prev'].includes(env);
export const QrcodeValidate = props => {
    const { onLogin, type = 'common', onUnLockAppSuccess } = props;
    const isUnLockApp = type === 'unlockApp';
    const [qrUrl, setQrUrl] = useState();
    const [errmsg, setErrmsg] = useState('');
    const [actBtnText, setActBtnText] = useState('');
    const [loginErr, setLoginErr] = useState('');
    const [isScanSuccess, setIsScanSuccess] = useState(false);
    const [title, setTitle] = useState(isUnLockApp ? getIn18Text('LOCK_LOGIN_MODAL_TITLE') : getIn18Text('QRCODE_LOGIN'));
    const [loginTip, setLoginTip] = useState('');
    const QRCodeContainerClass = 'lingxi-login-qr-code-container';
    const resetState = () => {
        setErrmsg('');
        setActBtnText('');
        setIsScanSuccess(false);
        setTitle(getIn18Text('QRCODE_LOGIN'));
        setLoginTip('');
        setLoginErr('');
    };
    const refresh = () => {
        const imgUrl = loginApi.getLoginQrCodeImgUrl();
        resetState();
        setQrUrl(imgUrl);
    };
    const getHasQrCodeContainer = () => {
        const el = document.querySelector('.' + QRCodeContainerClass);
        if (!el) {
            return false;
        }
        let rect = el.getBoundingClientRect();
        if (rect.width === 0 && rect.height === 0) {
            return false;
        }
        if (document.visibilityState === 'hidden') {
            return false;
        }
        return true;
    };
    useEffect(() => {
        if (loginErr) {
            setLoginTip('');
        }
    }, [loginErr]);
    const getHasVisibilityState = () => {
        return inWindow() ? (document.visibilityState ? true : false) : false;
    };
    useEffect(() => {
        setQrUrl(loginApi.getLoginQrCodeImgUrl());
    }, []);
    function onVisibilityChanged() {
        setTimeout(() => {
            let visibilityState = document.visibilityState;
            if (visibilityState === 'visible') {
                checkQRCodeStatus();
            }
        }, 0);
    }
    useEffect(() => {
        const hasVisibilityState = getHasVisibilityState();
        if (hasVisibilityState) {
            const eventName = 'visibilitychange';
            document.addEventListener(eventName, onVisibilityChanged);
            return () => {
                document.removeEventListener(eventName, onVisibilityChanged);
            };
        }
        return;
    }, []);
    const delayCheckQRCodeStatus = async () => {
        const hasQrCodeContainer = getHasQrCodeContainer();
        if (!hasQrCodeContainer)
            return;
        await wait(1000);
        checkQRCodeStatus();
    };
    const loginByQRCode = async (loginUrl, node) => {
        const res = await loginApi.loginByQRCode(loginUrl, node);
        if (res.showDeviceReport) {
            onLogin(res);
            return;
        }
        if (res.pass || (!res.pass && !res.errmsg)) {
            onLogin(res);
            if (res.showMailMasterDownload) {
                refresh();
            }
        }
        else {
            if (res.errmsg) {
                doLoginPageClickDataTrack(systemApi.getIsAddAccountPage() ? '账号管理-添加账号登录页' : '原始启动登录页', 'false', res.errmsg, 'qrcode');
            }
            setLoginErr(res.errmsg);
        }
    };
    useEffect(() => {
        setQrUrl(loginApi.getLoginQrCodeImgUrl());
    }, []);
    const handleQrCodeImgLoaded = async () => {
        await wait(1000);
        checkQRCodeStatus();
    };
    const checkQRCodeStatus = async () => {
        if (!isRequestingQrCodeStatus) {
            isRequestingQrCodeStatus = true;
        }
        else {
            return;
        }
        const res = await loginApi.getQRCodeStatus(undefined, isUnLockApp);
        isRequestingQrCodeStatus = false;
        const hasQrCodeContainer = getHasQrCodeContainer();
        if (!hasQrCodeContainer)
            return;
        if (!res.success) {
            setIsScanSuccess(false);
            setLoginErr(res.errMsg);
            return;
        }
        if (res.data) {
            const resData = res.data;
            const codeStatus = resData.status;
            switch (codeStatus) {
                case QrCheckStatus.scaning:
                    setIsScanSuccess(true);
                    setTitle(getIn18Text('SCAN_SUCCESS'));
                    setLoginTip(getIn18Text('CONFIRM_LOGIN_ONAPP'));
                    break;
                case QrCheckStatus.pass:
                    if (isUnLockApp) {
                        const loginUrl = resData.loginUrl;
                        if (loginUrl) {
                            const uid = new URL(loginUrl).searchParams.get('uid');
                            if (uid) {
                                const currentUser = systemApi.getCurrentUser();
                                if ((currentUser && currentUser.id === uid) || ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.loginAccount) && currentUser.loginAccount === uid)) {
                                    onUnLockAppSuccess && onUnLockAppSuccess();
                                    return;
                                }
                            }
                        }
                        setLoginErr(getIn18Text('UNLOCK_OTRER_ACCOUNT_ERROR'));
                        refresh();
                        return;
                    }
                    loginByQRCode(resData.loginUrl, resData.node);
                    setLoginTip(getIn18Text('LOGINING'));
                    break;
                case QrCheckStatus.expire:
                    setErrmsg(getIn18Text('QRCODE_OUTDATE'));
                    setIsScanSuccess(false);
                    setActBtnText(getIn18Text('SHUAXIN'));
                    break;
                default:
                    break;
            }
            if ([QrCheckStatus.scaning, QrCheckStatus.init].includes(codeStatus)) {
                delayCheckQRCodeStatus();
            }
        }
    };
    useEffect(() => {
        trackerApi.track('pcLogin_show_QRcode_loginPage');
    }, [qrUrl]);
    const appQrCode = (React.createElement("div", { className: "appQrCodeContainer" },
        React.createElement("div", { className: "appQrCode", style: { background: `url(${isOnline ? qrCodeImage : qrCodeTestImage}) no-repeat center center / cover` } }),
        React.createElement("div", { className: "appDownText" }, getIn18Text('APP_DOWNLOAD'))));
    return (React.createElement("div", { key: "qrcodeLogin", className: `${styles.container} ${QRCodeContainerClass}` },
        React.createElement("div", { className: styles.title }, title),
        React.createElement("div", { className: styles.qrcodeContainer },
            React.createElement("div", { className: styles.qrcodeWrapper },
                qrUrl && React.createElement("img", { onLoad: handleQrCodeImgLoaded, src: qrUrl, alt: "QRCodeImg", width: "176", height: "176" }),
                React.createElement("div", { className: styles.errTip, style: { display: errmsg || actBtnText || isScanSuccess ? 'flex' : 'none' } },
                    errmsg && React.createElement("div", { className: styles.errTipText }, errmsg),
                    actBtnText && (React.createElement("div", { className: styles.errActBtn, onClick: refresh }, actBtnText)),
                    isScanSuccess && React.createElement("div", { className: styles.successIcon }))),
            React.createElement("div", { className: styles.qrcodeTip })),
        loginErr && React.createElement("div", { className: styles.qrcodeLoginErr }, loginErr),
        React.createElement("div", { className: styles.qrcodeLoginTip },
            !loginTip && (React.createElement(React.Fragment, null, process.env.BUILD_ISEDM && !isUnLockApp ? (React.createElement("div", { className: styles.qrcodeTip2 },
                React.createElement("span", { className: styles.qrcodeTip2Text }, getIn18Text('APP_QRCODE')),
                React.createElement("span", { className: styles.qrcodeTip2Sep }, "|"),
                React.createElement(Popover, { content: appQrCode, placement: "topLeft" },
                    React.createElement("span", { className: styles.qrcodeTip2LinkContainer },
                        React.createElement("span", { className: styles.qrcodeTip2Link }, isUnLockApp ? getIn18Text('SCAN_AND_UNLOCK') : getIn18Text('APP_QRCODE_TIP')),
                        React.createElement("span", { className: styles.qrcodeTip2Icon }))))) : (React.createElement(React.Fragment, null,
                getIn18Text('PLEASE_USE'),
                React.createElement("a", { href: "https://office.163.com?from=scan-qrcode", target: "_blank" }, process.env.BUILD_ISEDM ? getIn18Text('WANGYIWAIMAOTONG') : getIn18Text('WANGYILINGXIBAN')),
                ' ',
                isUnLockApp ? getIn18Text('SCAN_AND_UNLOCK') : getIn18Text('SCAN_AND_LOGIN'))))),
            loginTip && React.createElement(React.Fragment, null, loginTip))));
};
export default QrcodeValidate;
